import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import Filter from './Filter';
import { isPhoneSelector } from '../../selectors/configSelectors';
import { scrollTo } from '../../actions/view';
import { rootPageUri } from '../../config/uri';
import { pushWithQueryParams } from '../../services/uri';

const mapStateToProps = state => ({
  isSmallScreen: isPhoneSelector(state),
});

const mapDispatchToProps = dispatch => ({
  goBack: () => dispatch(goBack()),
  openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
  resetScrollPosition: () => dispatch(scrollTo(0)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Filter);



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/filter_container.js